<rotec-form-v2
  [form]="stepForm"
  (formChange)="stepForm = $event"
  [fields]="schedulingFields"
  [model]="machineTaskModel"
  (modelChange)="machineTaskModelChange.emit($event)"
>
</rotec-form-v2>
